import React from 'react';
import * as R from 'ramda';
import { indexMap } from '@cd/utils';
import { FormCardRHF } from '@cd/rhf';
import { InputRHF } from '@cd/rhf';
import useDeletePayment from './../fetch/useDeletePayment';

const DeletePayment = ({ selected }) => {
	const record = {
		transactions: R.compose(R.uniq, R.pluck)('transaction_id', selected)
	};
	const { mutate } = useDeletePayment();

	return (
		<div>
			<FormCardRHF
				defaultValues={record}
				onSubmit={values => {
					mutate({
						...values
					});
				}}
				ignoreDirty
				title="DELETE PAYMENT"
				subtitle="Delete selected payments"
				okButtonTitle="DELETE"
				dirty={true}>
				{indexMap(
					(values, index) => (
						<InputRHF
							fullWidth
							margin="normal"
							name={`transactions[${index}]`}
							type="text"
							label={`Transaction: ${index + 1}`}
						/>
					),
					record.transactions
				)}
			</FormCardRHF>
		</div>
	);
};

export default DeletePayment;
